module.exports = __webpack_public_path__ + "img/poocoin.ac9f1ca0.png";